import React, {useState,useEffect,useMemo} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ArrowRightIcon from '@mui/icons-material/ArrowRightAlt';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import VisitConfirm from './VisitConfirm';
import BottomButtons from './BottomButtons';
import {Owner,Visit} from './Inc';
import Ajax from './Ajax';
import Toast from './Toast';
//import Success from './Success';
import Title from './Title';
import Loading from './Loading';

interface VisitInputProps {
	owner:Owner,
}

//let isThanks = false;

const VisitInput = (props:VisitInputProps)=> {
	const classes = useStyles();

    const def:Visit = {
        consign: false,
		takeback: false,
		date: '',
        text: "",
    }
    const [values, setValues] = useState(def);
    const [toast,setToast] = useState("");
    const [flags,setFlags] = useState({
        isLoading: false,
        isConfirm: false,
        isSuccess: false,
    });
	const dates = useMemo(()=>{
		let weekDay = ["日", "月", "火", "水", "木", "金", "土"];
		const day = new Date();

		const list:string[] = [];
		for( let i=0; i<14; i++ ){
			list.push( String(day.getFullYear())+"年"+String(day.getMonth()+1)+"月"+String(day.getDate())+"日（"+weekDay[day.getDay()]+"）");
			day.setDate(day.getDate() + 1);
		}
		return list;
	},[])

    const handleModalClose = ()=>{
		setFlags({...flags,"isConfirm":false});
	};

	const handleChange = (name: keyof Visit) => (event: React.ChangeEvent<HTMLInputElement>) => {
		setValues({ ...values, [name]: event.target.value });
	};
	const handleChangeSelect = (name: keyof Visit) => (event: SelectChangeEvent) => {
		setValues({ ...values, [name]: event.target.value });
    };
	const handleChangeCheckbox = (name: keyof Visit) => (event: React.ChangeEvent<HTMLInputElement>) => {
		let flag = false;
		if( event.target.checked ){
			flag = true;
		}
		setValues({ ...values, [name]: flag });
	};

	const closeToast = ()=>{
        setToast("");
	}
    const validate = ()=>{
		if( values.consign!==true && values.takeback!==true ){
			setToast("訪問の狙いを選択してください。");
		} else if( values.date==="" ){
            setToast("訪問希望日を選択してください。");
        } else {
            setFlags({...flags,"isConfirm":true});
        }
    }
    const send = ()=>{
        setFlags({...flags,"isLoading":true});
		Ajax.setEditorId(props.owner.owner_id);
        Ajax.send("visit/send",values,(res:any)=>{
            if( res.ok ){
                //isThanks = true;
                setFlags({"isLoading":false,"isConfirm":false,"isSuccess":true});
                setValues(def);
                window.scrollTo(0, 0);
            } else {
                setFlags({"isLoading":false,"isConfirm":false,"isSuccess":false});
                setToast("送信に失敗しました。");
            }
        });
        
    }
    useEffect( ()=>{
        //isThanks = false;
		//isThanks = true;
		setFlags({"isLoading":false,"isConfirm":false,"isSuccess":false});
        window.scrollTo(0,0);
    },[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div className={classes.root+" "+classes.policy}>
			{flags.isSuccess ? (
				<Paper className={classes.paper}>
					<div style={{marginBottom:"3em"}}>
						<Title text="訪問予約のご要望をうけたまわりました。" size={2}/>
						<div className={classes.section}>
							<p><b>store@retro-biz.com</b>から確認メールを送信いたしました。</p>
							<p>
								担当者が予定を確認した上で予約確定となります。<br/>
								なるべく早めに返信いたしますので今しばらくお待ち下さい。（通常１営業日以内）
							</p>
						</div>
						<div className={classes.section}>
							<p>また、納品書の作成や商品引取りの申請など、ご訪問の前に必要な手続きをお忘れにならないようお願いいたします。</p>
						</div>
						<div className={classes.section}>
							<Link to="/letter" className={classes.linkText}><Button variant="text" color="primary" startIcon={<ArrowRightIcon/>}>納品書作成</Button></Link><br/>
							<Link to="/takeback" className={classes.linkText}><Button variant="text" color="primary" startIcon={<ArrowRightIcon/>}>商品引取り</Button></Link>
						</div>
					</div>
				</Paper>
			):(
			<React.Fragment>
				<Paper className={classes.paper}>
					<Title text="井の頭倉庫" size={1} icon="cart"/>
					<div style={{marginBottom:"2em"}}>
						<p>近隣にお住いの作家さんは、吉祥寺・井の頭公園のそばにある井の頭倉庫でも納品や商品引取の受付が可能です。<br/>
						一般のお客様が間違ってご入店なさらないようにCLOSEDの札がかかっていますが気にせずお入り下さい。</p>
					</div>
					<Grid container spacing={2} style={{marginBottom:"2em"}}>
						<Grid item xs={12} md={6}>
							<div style={{padding:'2em',border:'1px solid silver'}}>
								<h3 style={{fontSize:'120%',margin:'0',marginBottom:'1em',padding:'0em'}}>井の頭倉庫でできること</h3>
								<CheckIcon style={{color:'green',verticalAlign:'middle'}}/> 納品<span style={{fontSize:'90%',color:'#666666'}}>（納品書が必要）</span><br/>
								<CheckIcon style={{color:'green',verticalAlign:'middle'}}/> 商品引取<span style={{fontSize:'90%',color:'#666666'}}>（前日までに商品引取の手続きが必要）</span><br/>
							</div>
						</Grid>
						<Grid item xs={12} md={6}>
							<div style={{padding:'2em',border:'1px solid silver'}}>
								<h3 style={{fontSize:'120%',margin:'0',marginBottom:'1em',padding:'0em'}}>できないこと</h3>
								<CloseIcon style={{color:'red',verticalAlign:'middle'}}/> 事前審査<span style={{fontSize:'90%',color:'#666666'}}>（対面での審査は行っておりません）</span><br/>
								<CloseIcon style={{color:'red',verticalAlign:'middle'}}/> 販売<span style={{fontSize:'90%',color:'#666666'}}>（販売はオンラインのみです）</span><br/>
							</div>
						</Grid>
					</Grid>					
					<table style={{marginBottom:"1em"}} className="visitTimeTable">
						<tbody>
						<tr>
							<th colSpan={2}>井の頭倉庫　受付時間</th>
						</tr>
						<tr>
							<td className='week'>月・水・木・金</td>
							<td>13:00～19:00</td>
						</tr>
						<tr>
							<td className='week'>日・祝</td>
							<td>13:00～17:00</td>
						</tr>
						<tr>
							<td className='week'>上記以外<br/>（火・土・夜間など）</td>
							<td>応相談</td>
						</tr>
						</tbody>
						<caption style={{captionSide:'bottom',textAlign:'right'}}>※火、土は祝日の場合も「応相談」です。</caption>
					</table>
					<div style={{marginBottom:"1em"}}>
					・上記時間内であっても業務の都合などで受付できないことが多いですので、なるべく「訪問予約」をしてからおいで下さい。<br/>
					・徒歩や自転車で来られる近隣の作家さん向けのサービスです。遠方の作家さんには郵送や宅配便を強くオススメいたします。<br/>
					・応相談の場合も「訪問予約」でご希望の日時等をお知らせください。<br/>
					・訪問予定日の2週間前から「訪問予約」できます。当日の予約も可能です。<br/>
					</div>
					<div style={{textAlign:'right',marginBottom:"4em"}}>
						<a href="#form"><Button variant="text" color="primary"><ArrowRightIcon/> 訪問予約フォーム</Button></a>
					</div>
					<Divider/>
					<div style={{textAlign:'center',marginBottom:"2em"}}>
						<h3>架空ストア　井の頭倉庫</h3>
						<div style={{marginBottom:'0.5em'}}>東京都三鷹市井の頭4-26-7<br/>
						<a href="https://goo.gl/maps/mFyMWw19ss3onkr1A" rel="noopener noreferrer" target="_blank"><Button variant="outlined" color="primary" size="small">google mapで見る</Button></a></div>
						<div style={{width:'100%',maxWidth:'498px',margin:'0 auto'}}>
							<img src="https://store.retro-biz.com/img/default/about/map.gif" alt="架空ストアの地図" style={{width:'100%'}}/><br/>
						</div>
						<div style={{width:'100%',maxWidth:'498px',margin:'0 auto',color:'#333333',fontSize:'90%',backgroundColor:'#F5F5F5',textAlign:'left',padding:'1em',boxSizing:'border-box'}}>
							・吉祥寺駅（JR/京王井の頭線）から徒歩10分<br/>
							・井の頭駅（京王井の頭線）から徒歩15分<br/>
							・三鷹駅（JR）から徒歩20分<br/>
							・井の頭文化園バス停から徒歩5分<br/>
						</div>
					</div>
					<Divider/>
					<div style={{marginBottom:"2em"}}>
						<div style={{marginBottom:"2em"}}/>
						<h2 style={{marginBottom:'2em'}} id="form"><ContactSupportIcon style={{verticalAlign:'middle'}}/> 訪問予約をする</h2>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={4}>
								<FormControl className={classes.formControl} fullWidth={true} error={!values.consign && !values.takeback}>
									<FormLabel component="label" className={classes.formLabel}>訪問の狙い<span className="formRequired">必須</span></FormLabel>
									<FormGroup row={true} style={{marginTop:'1em'}}>
										<FormControlLabel
											control={
												<Checkbox
													checked={values.consign}
													onChange={handleChangeCheckbox('consign')}
													value={true}
													color="primary"
													className={classes.checkbox}
												/>
											}
											label="納品"
										/>
										<FormControlLabel
											control={
												<Checkbox
													checked={values.takeback}
													onChange={handleChangeCheckbox('takeback')}
													value={true}
													color="primary"
													className={classes.checkbox}
												/>
											}
											label="商品引取"
										/>
									</FormGroup>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={8}>
								<FormControl className={classes.formControl} fullWidth={true} error={values.date===""}>
									<FormLabel component="label" className={classes.formLabel}>訪問希望日<span className="formRequired">必須</span></FormLabel>
									<Select
										value={values.date}
										onChange={handleChangeSelect('date')}
										margin="none"
										variant="standard"
										className={classes.select}
									>
										{dates.map((date:string,index:number) => {
											const key = "date"+index;
											return (
												<MenuItem key={key} value={date}>
													{date}
												</MenuItem>
											)
										})}
									</Select>
								</FormControl>
							</Grid>

							<Grid item xs={12} sm={12}>
								<FormControl className={classes.formControl} fullWidth={true} required={false} error={values.text===""}>
									<FormLabel component="label" className={classes.formLabel}>備考（第2希望日や訪問時間など）</FormLabel>
									<TextField
										id="topic_body"
										fullWidth
										multiline
										rows="4"
										value={values.text}
										onChange={handleChange('text')}
										className={classes.textfield}
										margin="normal"
										variant="outlined"
									/>
								</FormControl>
							</Grid>
						</Grid>
					</div>
					<BottomButtons button1='内容の確認' onClick1={validate}/>
				</Paper>
			</React.Fragment>
			)}          
			<VisitConfirm send={send} close={handleModalClose} isOpen={flags.isConfirm} visit={values}/>
			<Toast close={closeToast} mes={toast}/>
			<Loading isLoading={flags.isLoading}/>
		</div>
	);
}

export default VisitInput;
